import React from 'react';
import {StyleSheet, View} from 'react-native';
import {Typography, Icon, Button} from 'src/components';
import {colors} from 'src/assets';
import LocalText from 'src/local';

export type Props = {
  onCreate?: () => void;
};

const Index: React.FC<Props> = ({onCreate}) => {
  return (
    <View style={styles.container}>
      <Icon name={'plus'} size={80} color={colors.chokuGray8} />
      <Typography
        variant={'h1'}
        text={LocalText.screens.offers.notFound.text}
        containerStyle={styles.h1}
      />
      <Typography
        variant={'body'}
        text={LocalText.screens.offers.notFound.description}
        containerStyle={styles.body}
        textStyle={styles.bodyText}
      />
      <Button
        containerStyle={styles.btnContainer}
        icon={'plus-circle-arrows'}
        title={LocalText.screens.offers.notFound.action}
        onPress={onCreate}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 40,
    paddingHorizontal: 16,
  },
  h1: {
    marginTop: 50,
  },
  body: {
    marginTop: 24,
  },
  bodyText: {
    color: colors.chokuGray5,
    textAlign: 'center',
    lineHeight: 24,
    letterSpacing: 1.2,
  },
  btnContainer: {
    width: '100%',
    marginTop: 44,
  },
});

export default Index;
